document.addEventListener('DOMContentLoaded', () => {
    const SELECTORS = {
      BUBBLE: '.featured__bubbles:not(.featured__bubbles--only-subcategories) .featured__bubble',
      BUBBLE_GROUP: '.featured__bubbles:not(.featured__bubbles--only-subcategories) .featured__bubble-group',
      BUBBLE_GROUP_LINK: '.featured__bubble-group .featured__bubble-link'
    };
    const CLASSLIST = {
        BUBBLE_GROUP: 'featured__bubble-group',
        EXPANDED: 'expanded',
    };

    function toggleBubbleChilds(bubble, toggle) {
        if (toggle) {
            bubble.closest(SELECTORS.BUBBLE_GROUP)?.classList.toggle(CLASSLIST.EXPANDED);
        } else {
            bubble.closest(SELECTORS.BUBBLE_GROUP)?.classList.remove(CLASSLIST.EXPANDED);
        }
    }

    function calculateBubbleListPosition(bubble) {
        const bubbleList = bubble.nextElementSibling;
        if (bubbleList) {
            const bubbleRect = bubble.getBoundingClientRect();
            bubbleList.style.left = `${bubbleRect.left}px`;
        }
    }

    function addFeaturedBubbleEvents() {
      const bubbleGroupLinks = document.querySelectorAll(SELECTORS.BUBBLE_GROUP_LINK);
      const bubbleGroups = document.querySelectorAll(SELECTORS.BUBBLE_GROUP);
      bubbleGroupLinks.forEach((bubble) => {
        bubble.addEventListener('click', (event) => {
            if (event.target.closest(SELECTORS.BUBBLE)?.classList.contains(CLASSLIST.BUBBLE_GROUP)) {
                event.preventDefault();
                calculateBubbleListPosition(bubble);
                toggleBubbleChilds(bubble, true);
            }
        });
      });
      bubbleGroups.forEach((group) => {
        group.addEventListener('mouseout', (event) => {
            if (!group.contains(event.relatedTarget)) {
                toggleBubbleChilds(group, false);
            }
        });
      });
    }

    addFeaturedBubbleEvents();
  });